import type { types } from "@fraction/shared";
import { ArrowRight } from "lucide-react";
import { useCallback } from "react";

import { useOpenNotificationTarget } from "src/hooks/useOpenNotificationTarget";

import { NotificationCardLayout } from "./NotificationCardLayout";

function formatStatus(status: string): string {
  return status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function StatusChangeCard({
  notification,
  onDismiss,
  count,
}: {
  notification: types.ApplicationStatusChangeNotification;
  onDismiss: () => void;
  count?: number;
}) {
  const { openRoute } = useOpenNotificationTarget();

  const handleClick = useCallback(() => {
    openRoute(`/app/${notification.applicationId}`);
    onDismiss();
  }, [openRoute, notification.applicationId, onDismiss]);

  return (
    <NotificationCardLayout
      icon={ArrowRight}
      iconBg="bg-amber-100"
      iconColor="text-amber-600"
      title="Status changed"
      applicationEid={notification.applicationEid}
      applicantNames={notification.applicantNames}
      onClick={handleClick}
      count={count}
    >
      <p className="text-sm text-foreground/80">
        <span className="font-medium">{formatStatus(notification.fromStatus)}</span>
        {" → "}
        <span className="font-semibold">{formatStatus(notification.toStatus)}</span>
      </p>
      <p className="text-xs text-muted-foreground">by {notification.changedByName}</p>
    </NotificationCardLayout>
  );
}
